import {
  getPlayerIconDirectory,
  type PlayerButtonColor,
} from "app/player/getPlayerThickIcon"

export type PlayerVolumeColor = PlayerButtonColor

const LIGHT_ICON_DIR = "/icons/player/thick"

type VolumeTier = "mute" | "low" | "mid" | "high"

const TIER_FILES: Record<VolumeTier, string> = {
  mute: "ico_vol_mute.svg",
  low: "ico_vol_low.svg",
  mid: "ico_vol_mid.svg",
  high: "ico_vol_high.svg",
}

const ACTIVE_TIER_FILES: Partial<Record<VolumeTier, string>> = {
  mute: "ico_vol_mute_active.svg",
}

function getVolumeTier(volume: number): VolumeTier {
  if (volume === 0) {
    return "mute"
  }
  if (volume < 0.33) {
    return "low"
  }
  if (volume < 0.66) {
    return "mid"
  }
  return "high"
}

export function getVolumeIcon(
  color: PlayerVolumeColor,
  volume: number,
  { active = false }: { active?: boolean } = {}
) {
  const tier = getVolumeTier(volume)

  if (active && ACTIVE_TIER_FILES[tier]) {
    return `${LIGHT_ICON_DIR}/${ACTIVE_TIER_FILES[tier]}`
  }

  return `${getPlayerIconDirectory(color)}/${TIER_FILES[tier]}`
}
